/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

class ListDropdownWrapper extends React.Component {
  static propTypes = {
    selectedItemId: PropTypes.string,
    handleOnOptionClick: PropTypes.func,
    isOpen: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.element).isRequired,
    noOptionsMessage: PropTypes.string,
  }

  static defaultProps = {
    selectedItemId: '',
    isOpen: false,
    handleOnOptionClick: () => { },
    noOptionsMessage: 'Nothing found',
  }

  constructor(props) {
    super(props);
    this.state = {
      selectedItemId: props.selectedItemId,
      isOpen: props.isOpen,
      searchText: '',
    };
  }

  componentDidMount = () => {
  }

  componentDidUpdate = (prevProps) => {
    const { isOpen, selectedItemId } = this.props;
    const { searchText } = this.state;
    if (isOpen !== prevProps.isOpen
      || selectedItemId !== prevProps.selectedItemId) {
      this.setState(() => ({ isOpen, searchText: isOpen ? searchText : '', selectedItemId }));
    }
  }

  changeClass = ({ currentTarget }, css, isOn) => {
    currentTarget.classList[isOn ? 'add' : 'remove'](css);
  }

  onDropdownSearchChange = (e) => {
    this.setState({ searchText: e.target.value });
  }

  handleOptionClick = (e) => {
    const itemId = Number(e.target.getAttribute('data-item-id'));
    if (itemId > 0) {
      const { handleOnOptionClick } = this.props;
      handleOnOptionClick(itemId);
    }
    e.stopPropagation();
  }

  handleOptionMouseOver = (e) => {
    this.changeClass(e, styles.highlightItem, true);
  }

  handleOptionMouseOut = (e) => {
    this.changeClass(e, styles.highlightItem, false);
  }

  convertOptionsToHtml = (options) => {
    const result = [];
    if (options.length) {
      options.forEach((option) => {
        if (option.type === 'option') {
          result.push(this.convertOptionToHtml(option));
        } else if (option.type === 'optgroup') {
          result.push(this.convertOptGroupToHtml(option));
        }
      });
    }
    return result;
  }

  containsSearchText = (text) => {
    const { searchText } = this.state;
    const searchTextTrimmed = searchText.toLowerCase().trim();
    if (searchTextTrimmed.length) {
      return text.toLowerCase().includes(searchTextTrimmed);
    }
    return true;
  }

  convertOptionToHtml = (option) => {
    const { value, children } = option.props;
    const optionText = children;
    if (this.containsSearchText(optionText)) {
      const { selectedItemId } = this.state;
      const itemId = Number(value);
      let optionClass = styles.dropdownItem;
      if (itemId === selectedItemId) {
        optionClass += ` ${styles.selectedItem}`;
      }
      return (
        <li
          className={optionClass}
          key={value}
          data-item-id={itemId}
          onMouseOut={this.handleOptionMouseOut}
          onBlur={this.handleOptionMouseOut}
          onMouseOver={this.handleOptionMouseOver}
          onFocus={this.handleOptionMouseOver}
          onClick={this.handleOptionClick}
        >
          {optionText}
        </li>
      );
    }
    return null;
  }

  convertOptGroupToHtml = (optgroup) => {
    const options = [];
    const { label, children } = optgroup.props;
    const optGroupLabel = <strong className={styles.itemGroup}>{label}</strong>;
    children.forEach((option) => {
      const optionHtml = this.convertOptionToHtml(option);
      if (optionHtml) {
        options.push(optionHtml);
      }
    });
    if (options.length) {
      const groupClasses = `${styles.dropdownGroup} ${styles.dropdownItem}`;
      const optionsGroup = <ul className={styles.dropdownNestedItems}>{options.map(option => option)}</ul>;
      return (
        <li className={groupClasses} key={label}>
          {optGroupLabel}
          {optionsGroup}
        </li>
      );
    }
    return null;
  }

  renderDropdown = () => {
    const { options } = this.props;
    return this.convertOptionsToHtml(options);
  }

  render = () => {
    const { isOpen } = this.state;
    const dropdownOptions = this.renderDropdown();
    const { noOptionsMessage } = this.props;
    return (
      <>
        {isOpen && (
          <span
            className={styles.dropdownContainer}
          >
            <span className={styles.searchContainer}>
              <input
                className={styles.dropdownSearch}
                type="search"
                spellCheck="false"
                autoComplete="off"
                autoCorrect="off"
                onChange={this.onDropdownSearchChange}
                onFocus={this.onFocusHandle}
              />
            </span>
            <span className={styles.dropdownOptions}>
              {
                dropdownOptions.reduce((show, value) => show || !!value, false)
                  ? dropdownOptions
                  : <div className={styles.noListsMessage}>{noOptionsMessage}</div>
              }
            </span>
          </span>
        )}
      </>
    );
  }
}

export default ListDropdownWrapper;
